import {Route} from '@angular/router';
import {canAuthGuard} from '@shared/guards/can-auth-guard';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';

export const CUSTOM_DOMAIN_ROUTE: Route = {
  path: EEndpointApp.CustomDomain,
  canActivate: [canAuthGuard],
  children: [
    {
      path: EEndpointApp.Overview,
      title: 'overview',
      loadComponent: () => import('./overview/overview.component').then((m) => m.OverviewComponent),
    },
    {
      path: ':customDomainId',
      title: 'wizard-dns',
      loadComponent: () => import('./wizard-dns/wizard-dns.component').then((m) => m.WizardDnsComponent),
    },
    {
      path: '',
      redirectTo: EEndpointApp.Overview,
      pathMatch: 'prefix',
    },
  ],
};
